class Procedure {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // ------------------------
    // PC タブ切り替え
    // ------------------------
    $('.js-tab-trigger > div').click(function() {
      $(this).addClass('is-active');
      $(this).siblings().removeClass('is-active');

      $('.js-tab-inner > div').eq($(this).index()).siblings().css({'display':'none'});
      $('.js-tab-inner > div').eq($(this).index()).fadeIn(300);
    })

    // ------------------------
    // SP アコーディオン
    // ------------------------
    $('.js-sp-trigger').click(function() {
      $(this).toggleClass('is-active')
      $(this).next().slideToggle(500);
    })
  }
}